export class BevalidaTransaction {
    constructor(
      public ip = '',
      public country = 0,
      public email = '',
      public pass = '',
      public token = '',
      public tyc = false,
    ) { }
}
